import styled from "styled-components";

export const StyledLayout = styled.div``;

export const CoreContent = styled.div`
  background-color: ${({ theme }) => theme.color.background.primary};
  min-height: 100vh;
  overflow: hidden;
`;
